/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/**
 * sendGreetingCardToCardIsle
 * url - /checkout/cgc/v2/greeting/cardisle
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {String} args.jwtToken
 * @param {String} args.primaryBrand
 * @param {String} args.cartId
 * @param {String} args.cartItemId
 * @param {String} args.cardType
 * @param {String} args.card
 * @param {String} args.keyId
*/

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_FACADE = '/cgc/v2';
const RESOURCE_PAGE_ACTION = '/greeting/cardisle';

const sendGreetingCardToCardIsle = ({
    wcEnv, jwtToken, primaryBrand, cartId, cartItemId, cardType, cardTemplate, card, keyId,
}) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = `${RESOURCE_PAGE_FACADE}${RESOURCE_PAGE_ACTION}`;
    const payload = {
        primaryBrand,
        cartId,
        cartItemId,
        cardType,
        cardTemplate,
        card,
        keyId,
    };

    return restClient.postFacade(env, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default sendGreetingCardToCardIsle;
